define('models/user/profile/profile',["backbone",
        "models/shared/network/network_collection",
        "models/shared/securityquestions/securityquestion_collection",
        "models/shared/lookups/systext",            
], function (Backbone, NetworkList, SecurityQuestions, SystemText) {
    var NetworkItem = Backbone.Model.extend({
        urlRoot: function () {
            var url = pf.consumerURL + "/Profile";
            if (this.ID != null) {
                url = pf.consumerURL + "/" + this.ID + "/Profile";
            }
            return url;
        },
        defaults:{
            IsPrivate: true
        },
        initialize: function (options) {
            options = options || {};
            this.ID = options.ID;
            this.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, options.UG, pf.enums.imageTypeGUIDEnum.Actual, options.PU);
        },
        save: function (attributes, options) {

            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.FN = this.attributes.FirstName;
            data.MN = this.attributes.MiddleName;
            data.LN = this.attributes.LastName;
            data.C = this.attributes.City;
            data.S = this.attributes.State;
            data.STID = this.attributes.StateID;
            data.SD = this.attributes.ShortDescription;
            data.D = this.attributes.Description;
            data.UG = this.attributes.UserGUID;
            data.E = this.attributes.Email;
            data.Z = this.attributes.ZipCode;
            data.SQ = this.attributes.SecurityQuestions;
            data.CSTID = data.ConnectionStatusTypeID;
            data.MCT = data.ManageCount;
            data.PCT = data.ParticipantCount;
            data.AGID = this.attributes.AccountGUID;
            data.ALID = this.attributes.AllocationID;
            data.AP = this.attributes.AllocationPercentage;
            data.MCBT = this.attributes.MyContributions;
            data.RC = this.attributes.ReferralCode;
            data.RU = this.attributes.ReferralURL;
            data.SRU = this.attributes.ShortReferralURL;
            data.AE = this.attributes.AllocationEnabled;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        },
        validation: {
            ZipCode: {
                required: true,
                fn: function (value, attr, computedState)
                {
                    var value = this.attributes.ZipCode;
                    if (value != null && value != "" && value != "undefined")
                    {
                        var success = false;
                        $.ajax({
                            type: 'GET',
                            async: false,
                            url: pf.lookupsURL + "/ZipCodes/" + value,
                            contentType: "application/json",
                            success: function ()
                            {
                                success = true;
                            },
                            error: function ()
                            {
                                return sysText['FV']['invalid']['zipCode'];
                            }
                        });
                        if(!success)
                            return sysText['FV']['invalid']['zipCode'];
                    }
                }
            },
            FirstName: function (value, attr, computedState) {
                if (value == null || value == "") {
                    return sysText['FV']['required']['firstName'];
                }
            },
            MiddleName: {
                required: false
            },
            LastName: {
                required: true,
                msg: sysText['FV']['required']['lastName']
            },
        },
        parse: function (data) {
            data = data || {};

            //_gaq.push(['_trackEvent', 'Consumer', 'Profile', data.FN + ' ' + data.LN + '-' + data.UG, null, null]);
            gAnalytics('Profile', data.FN + ' ' + data.LN + '-' + data.UG, '');

            var response = {};
            response.UserGUID = data.UG;
            response.FirstName = data.FN;
            response.MiddleName = data.MN;
            response.LastName = data.LN;
            response.Email = data.E;
            response.ShortDescription = data.SD;
            response.Description = data.D;
            response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.UG, pf.enums.imageTypeGUIDEnum.Actual, data.PU);
            response.City = data.C;
            response.State = data.S;
            response.StateID = data.STID;
            response.IsEditable = data.IE;
            response.ZipCode = Array(Math.max(5 - String(data.Z).length + 1, 0)).join(0) + data.Z; 
            response.SecurityQuestions = new SecurityQuestions(data.SQ, { parse: true });
            response.Network = new NetworkList(data.NT, {
                parse: true
            });
            response.ConnectionStatusTypeID = data.CSTID;
            response.ConnectionEntityTypeID = data.CETID;
            response.ManageCount = data.MCT;
            response.ParticipantCount = data.PCT;
            response.AccountGUID = data.AGID;
            response.AllocationID = data.ALID;
            response.AllocationPercentage = data.AP;
            response.MyContributions = data.MCBT;
            response.IsPrivate = data.ISP;
            response.ReferralCode = data.RC;
            response.ReferralURL = data.RU;
            response.ShortReferralURL = data.SRU;
            response.AllocationEnabled = data.AE;
            return response;
        }
    });
    return NetworkItem;
});

